export class PatientAllergyModel {
    patientAllergyId: any;
    allergyType: any;
    allergyCode: any;
    allergyDescription: any;
    allergySeverity: any;
    allergyReactionDescription: any;
    allergyReactionDescriptionWithIds: any;
    onsetDate: any;
    resolvedDate: any;
    comments: any;
    recounciledData: any;
    resolved: any;
    allergyTypeId: any;
    allergySeverityId: any = "0";
    allergyReactionId: any = "0";
    allergyReactions: ItemList[];
    
    constructor() {
        this.patientAllergyId = "";
        this.allergyType = "";
        this.allergyCode = "";
        this.allergyDescription = "";
        this.allergySeverity = "";
        this.allergyReactionDescription = "";
        this.allergyReactionDescriptionWithIds = "";
        this.onsetDate = "";
        this.resolvedDate = "";
        this.comments = "";
        this.recounciledData = "";
        this.resolved = "";
        this.allergyTypeId = "";
        this.allergySeverityId = "";
        this.allergyReactionId = "";
    }
}
export class ItemList {
    allergyReactionId: any = '';
    allergyReactioNDescription: any = '';
    reconcileAllergyId: any = '';
}
export class PatientSocialHistoryModel {
    alcoholDay: any="";
    caffineUsage: any="";
    caffineUsageFrequency: any="";
    drugUse: any="";
    drugUseDetails: any="";
    education: any="";
    exercise: any="";
    exposure: any="";
    feelsSafe: any="";
    industryCode: any="";
    industryEndDate: any="";
    industryStartDate: any="";
    isReconcile: any="";
    notes: any="";
    riskAssessmentStructId: any="";
    seatbelts: any="";
    socialhxId: any="";
    suicideRisk: any="";
    tobaccoEndDate: any="";
    tobaccoStartDate: any="";
    tobaccoStatus: any="";
    tobaccoStatusCode: any="";
    tobaccoStatusIdPkstring: any="";
    educationDescription: any="";
    industryDescription: any="";
}
export class AllergyListModel {
    ALLERGY_CODE: any;
    Allergy_Concept_Id: any;
    Allergy_type_id: any;
    DESCRIPTION: any;
    IS_ENVIRON: any;
    IS_FOOD: any;
    IS_MED: any;
    _version_: any;
}
export class Allergies {
    patientAccount: any = '';
    practiceCode: any = '';
    language: any = '';
    allergyId: any = '';
    allergyTypeId: any = '';
    allergyCode: any = '';
    reactionId: any = '';
    allergyDescription: any = '';
    allergySeverityId: any = '';
    reactionDescription: any = '';
    allergyReactions: allergyReactions[] = []
    startDate: any = '';
    endDate: any = '';
    comments: any = '';
    allergyTyepIdUnSnomed: any = '';
    ipAddress: any = '';
    validUserID: any = '';
}
export class allergyReactions {
    reconcileAllergyId: any;
    allergyReactionId: any;
    allergyReactioNDescription: any;
}
export class severtydropdownListt {
    value: any;
    text: any;
}
export class DeleteAllergy {
    allergyId: any = "";
    patientAccount: any = "";
    practiceCode: any = "";
    modifiedBy: any = "";
    deleted: true;
}
export class NoKnownHistory {
    patienT_ACCOUNT: any = '';
    nO_KNOWN_ASSESSMENT: any = '';
    nO_KNOWN_MEDICATION: any = '';
    nO_KNOWN_ALLERGY: any = '';
    nO_KNOWN_FAMILY_HISTORY: any = '';
    modifieD_BY: any = '';
    modifeD_DATE: any = '';
    nO_KNOWN_ALLERGY_TALKCHECKIN: any = '';
    nO_KNOWN_IMMUNIZATION: any = '';
}
export class PracticeAndPatientCode {
    practiceCode: any;
    patientAccount: any;
}
export class IntakeFieldsSetting {
    //allergy settings
    isSearchAllergy: boolean = false;
    isAllergytype: boolean = false;
    isSeverity: boolean = false;
    isReaction: boolean = false;
    isObservationDate: boolean = false;
    isEndDate: boolean = false;
    isComments: boolean = false;
    
    // medication settings
    isIntakeAllowed: boolean = false;
    isDiagnosisAllowed: boolean = false;
    
    //Social hostory
    IsTobaccoAllowed: boolean = false;
    IsTobaccoFromAllowed: boolean = false;
    IsTobaccoToAllowed: boolean = false;
    IsAlcoholUsagePerDayAllowed: boolean = false;
    IsNotesAllowed: boolean = false;
    //Risk Assessment
    IsExerciseAllowed: boolean = false;
    IsDrugUseAllowed: boolean = false;
    IsSeatbeltAllowed: boolean = false;
    IsDiagnosisAllowedRisk: boolean = false;
    IsExposureAllowed: boolean = false;
    IsSafeAtHomeAllowed: boolean = false;
    
    //region Personal Information
    IsHighestEduAllowed: boolean = false;
    IsIndustryAllowed: boolean = false;
    IsEffectiveFromAllowed: boolean = false;
    IsEffectiveToAllowed: boolean = false;
    
    //Family hostory
    relationship: boolean = false;
    IsNameAllowed: boolean = false;
    IsAgeAllowed: boolean = false;
    IsDiagnosisAllowedFamily: boolean = false;
    IsAgeOnSetAllowed: boolean = false;
    IsDeceasedAllowed: boolean = false;
    
    //is social history
    isSocialHistoryAllowed: boolean = false;
    //is Risk Asse history
    isRistAssesmentAllowed: boolean = false;
    //is Personal info history
    isPersonalInfoAllowed: boolean = false;
    //is show social history tab
    isShowSocialHistoryTabs: boolean = false;
    
    
    //is show Surgical history tab
    isSurgicalHistory: boolean = false;
    isSurgicalDate: boolean = false;
    isSurgicalProcedure: boolean = false;
    isSurgicalPlace: boolean = false;
    isSurgicalComplications: boolean = false;
    
    
    
    //is show Past Hospitalization history tab
    isPastHospitalization: boolean = false;
    isPastHospitalizationDate: boolean = false;
    isPastHospitalizationReason: boolean = false;
    isPastHospitalizationDuration: boolean = false;

}
